import React from 'react';
import { Button } from './Button';
export function StickyCta() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-navy/95 border-t border-brand-blue-dark py-3 px-5 z-50 backdrop-blur-md" data-id="element-246">
      <Button href="https://librofy-store.myshopify.com/cart/47909760106717:1" className="max-w-full text-[15px] py-[15px] px-5" data-id="element-247">
        → QUIERO EL SISTEMA — $19.990 ARS
      </Button>
    </div>;
}